import * as React from "react";
import { Component } from "react";
import temple_pic from "../assets/images/temple_pic.jpg";
import Whatsapp_qr_code from "../assets/images/Whatsapp_qr_code.jpg";
import { ModalComponent } from "../components/shared/ModalComponent";
import {
  FaMobile,
  FaPhoneAlt,
  FaWhatsapp,
  FaFacebook,
  FaDirections
} from "react-icons/fa";
interface Props {}

interface State {}

export class Footer extends Component<Props, State> {
  JoinWhatsappModal: ModalComponent;
  contactUsModal: ModalComponent;
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <footer className="footer-container">
        <div className="footer-content">
          <div
            className="footer-section left"
            style={{
              maxWidth: "12%",
              textAlign: "left",
              alignSelf: "flex-start",
            }}
          >
            <ul>
              <div className="list-menu">
                <FaMobile
                  style={{ width: 25, height: 25, visibility: "hidden" }}
                />
                <li>
                  <a
                    href="https://drive.google.com/file/d/1gvBN272i5Grezi8fGLSzcpuDQmE0IVO-/view?usp=sharing"
                    target="_blank"
                  >
                    Privacy policy
                  </a>
                </li>
              </div>
              <div className="list-menu">
                <FaMobile
                  style={{ width: 25, height: 25, visibility: "hidden" }}
                />
                <li>
                  <a
                    href="https://drive.google.com/file/d/1ZUOD5HvNcOrMBdrjt341fc2YOo-VDhxS/view?usp=sharing"
                    target="_blank"
                  >
                    Terms of Service
                  </a>
                </li>
              </div>
              <div className="list-menu">
                <FaPhoneAlt style={{ width: 20, height: 20 }} />
                <li>
                  <a onClick={() => this.contactUsModal.show()}>Contact us</a>
                </li>
              </div>
            </ul>
          </div>

          <div
            className="footer-section center"
            style={{ maxWidth: "95%", textAlign: "center" }}
          >
            <img
              src={temple_pic}
              alt="Temple"
              className="footer-image"
              style={{ width: "100%" }}
            />
          </div>

          <div
            className="footer-section right"
            style={{
              maxWidth: "15%",
              textAlign: "left",
              alignSelf: "flex-start",
            }}
          >
            <ul style={{ alignSelf: "flex-start" }}>
              <div className="list-menu">
                <FaFacebook style={{ width: 20, height: 20 }} />
                <li>
                  <a
                    href="https://www.facebook.com/Hindutempleofcolorado"
                    target="_blank"
                  >
                  Follow us on Facebook
                  </a>
                </li>
              </div>
              <div className="list-menu">
                <FaWhatsapp style={{ width: 25, height: 20 }} />

                <li>
                  <a onClick={() => this.JoinWhatsappModal.show()}>
                  
                    Join our What's App community
                  </a>
                </li>
              </div>

              <div className="list-menu">
                <FaDirections style={{ width: 20, height: 20 }} />

                <li>
                  <a
                    href="https://www.google.com/maps/search/google+map+link+for+Hindu+Temple+and+Cultural+Center+of+The+Rockies,+7201+S+Potomac+St,+Centennial,+CO+80112/@39.5857715,-104.8329162,17z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI1MDEyMC4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                  >
               
                    Get Directions
                  </a>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <ModalComponent
          ref={(x) => (this.contactUsModal = x)}
          buttons={
            <div>
              <button
                type="button"
                className="btn bg-link"
                data-dismiss="modal"
                onClick={() => this.contactUsModal.hide()}
              >
                Close
              </button>
            </div>
          }
          dialogClassName="EventHeaderAddEdit"
          title={"Contact us"}
        >
          <div className="col-md-12 contact-modal-content font">
            <h3>Stay Connected</h3>
            <h5 style={{ width: "80%", textAlign: "center" }}>
              If you have a question, comment or suggestion about HTCCR website,
              please send it to:
            </h5>
            <a className="font-bold font-m" href="mailto:webmaster@htccr.org">
              webmaster@htccr.org
            </a>
            <h5 className="mt-5" style={{ width: "80%", textAlign: "center" }}>
              If you have a question, comment or suggestion about HTCCR
              facility, operation, or management, please send it to:
            </h5>
            <a className="font-bold font-m" href="mailto:feedback@htccr.org">
              feedback@htccr.org
            </a>
            <h5 className="mt-5" style={{ width: "80%", textAlign: "center" }}>
              You can reach our priests by phone:
            </h5>
            <h5 style={{ width: "80%", textAlign: "center" }}>
              Aditya Ji:{" "}
              <a className="font-bold font-m" href="tel:720-324-1489">
                720-324-1489{" "}
              </a>
              and Lokesh Ji:{" "}
              <a className="font-bold font-m" href="tel:720-324-1489">
                303-507-4826
              </a>
            </h5>
          </div>
        </ModalComponent>
        <ModalComponent
          ref={(x) => (this.JoinWhatsappModal = x)}
          buttons={
            <div>
              <button
                type="button"
                className="btn bg-link"
                data-dismiss="modal"
                onClick={() => this.JoinWhatsappModal.hide()}
              >
                Close
              </button>
            </div>
          }
          dialogClassName="mx-width-10 ack"
          title={"Join What's App"}
        >
          <div className="col-md-12 wp-modal-content">
            <h3>Join our What's App community</h3>
            <img
              src={Whatsapp_qr_code}
              alt="Whatsapp_qr_code"
              width={150}
              height={150}
            />
            <div className="wp-modal-content2" style={{ display: "contents" }}>
              <p className="mt-2">Scan the above Whatsapp QR code</p>
              <p className="mt-2">or</p>
              <a
                className="mt-2"
                href="https://chat.whatsapp.com/FE8cFFKLIOWKj5KZcZ4qAR"
                target="_blank"
              >
                Click here to join our What's App community
              </a>
            </div>
          </div>
        </ModalComponent>
      </footer>
    );
  }
}
